// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomePage_container__\\+8deC {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-left: auto; /* Centrează containerul pe orizontală */
  margin-right: auto; /* Centrează containerul pe orizontală */
  max-width: 1140px; /* Lățime maximă pentru container */
  box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 60px;
  justify-content: flex-start;
}

.HomePage_productsLink__KXY-7 {
  padding: 15px;
  margin: 10px 0px;
  border-radius: 8px;
  border: 1px solid #ddd;
  text-decoration: none;
  color: #333;
}

.HomePage_productsLink__KXY-7:hover {
  opacity: 0.7;
}

.HomePage_title__Iqtik {
  font-size: 35px;
  font-weight: 400;
}

.HomePage_products__MhUPY {
  display: flex;
  gap: 10px;
}

.HomePage_product__VIYY9 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.HomePage_productCard__rneTI {
  flex: 1 1;
  height: 260px; /* Înălțime fixă pentru card */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
  text-align: center;
  transition: transform 0.3s, color 0.3s;
}

.HomePage_productCard__rneTI:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.HomePage_imageContainer__4rajJ {
  height: 210px;
}

.HomePage_image__TnCdE {
  max-height: 100%; /* Asigură că imaginea respectă proporția */
  max-width: 100%; /* Asigură că imaginea respectă proporția */
  margin: auto; /* Centrează imaginea pe ambele axe */
  object-fit: contain; /* Păstrează proporțiile imaginii fără să o decupeze */
}

.HomePage_productName__lD1Hf {
  font-size: 1.1em;
  margin: 0;
  color: #333;
  display: -webkit-box; /* Suport pentru trunchiere pe mai multe linii */
  -webkit-line-clamp: 2; /* Permite maximum 2 linii */
  -webkit-box-orient: vertical; /* Setează direcția conținutului */
  overflow: hidden; /* Ascunde conținutul suplimentar */
  text-align: center;
}

.HomePage_productPrice__84XfT {
  font-size: 1em;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.HomePage_link__V6y8d {
  text-decoration: none; /* Elimină sublinierea */
  color: inherit; /* Menține culoarea textului */
}

.HomePage_contacts__D\\+S3D {
  display: flex;
  gap: 10px;
}

.HomePage_contact__izQPY {
  flex: 1 1;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #ddd;
  padding-top: 15px;
  padding-bottom: 15px;
}

.HomePage_city__eFPYX {
  font-size: 35px;
  font-weight: 400;
  color: #333;
}

.HomePage_address__4-Sq3 {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.HomePage_mapsLink__cfJqD {
  display: flex; /* Flexbox pentru afișarea orizontală */
  align-items: center; /* Aliniere verticală */
  gap: 8px; /* Spațiu între iconiță și text */
  color: #e63946; /* Culoare text */
  text-decoration: none; /* Fără subliniere */
  font-weight: bold;
  transition: opacity 0.3s ease; /* Tranziție pentru un efect mai plăcut */
}

.HomePage_mapsLink__cfJqD i {
  font-size: 20px;
  color: #333;
}

.HomePage_mapsLink__cfJqD span {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.HomePage_mapsLink__cfJqD:hover {
  opacity: 0.7; /* Face linkul mai palid */
}

.HomePage_phone__YJcpg {
  color: #e63946;
  font-size: 30px;
  font-weight: 500;
  text-decoration: none;
}

.HomePage_phone__YJcpg:hover {
  opacity: 0.7;
}

/* Responsive */
@media (max-width: 768px) {
  .HomePage_container__\\+8deC {
    padding-right: 10px;
    padding-left: 10px;
  }

  .HomePage_products__MhUPY {
    flex-direction: column;
  }

  .HomePage_contacts__D\\+S3D {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePage/HomePage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,iBAAiB,EAAE,wCAAwC;EAC3D,kBAAkB,EAAE,wCAAwC;EAC5D,iBAAiB,EAAE,mCAAmC;EACtD,sBAAsB,EAAE,kDAAkD;EAC1E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,eAAe,EAAE,2CAA2C;EAC5D,YAAY,EAAE,qCAAqC;EACnD,mBAAmB,EAAE,sDAAsD;AAC7E;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,oBAAoB,EAAE,gDAAgD;EACtE,qBAAqB,EAAE,4BAA4B;EACnD,4BAA4B,EAAE,kCAAkC;EAChE,gBAAgB,EAAE,mCAAmC;EACrD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa,EAAE,uCAAuC;EACtD,mBAAmB,EAAE,uBAAuB;EAC5C,QAAQ,EAAE,iCAAiC;EAC3C,cAAc,EAAE,iBAAiB;EACjC,qBAAqB,EAAE,oBAAoB;EAC3C,iBAAiB;EACjB,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-left: auto; /* Centrează containerul pe orizontală */\n  margin-right: auto; /* Centrează containerul pe orizontală */\n  max-width: 1140px; /* Lățime maximă pentru container */\n  box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding-top: 60px;\n  justify-content: flex-start;\n}\n\n.productsLink {\n  padding: 15px;\n  margin: 10px 0px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  text-decoration: none;\n  color: #333;\n}\n\n.productsLink:hover {\n  opacity: 0.7;\n}\n\n.title {\n  font-size: 35px;\n  font-weight: 400;\n}\n\n.products {\n  display: flex;\n  gap: 10px;\n}\n\n.product {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.productCard {\n  flex: 1;\n  height: 260px; /* Înălțime fixă pentru card */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #fff;\n  text-align: center;\n  transition: transform 0.3s, color 0.3s;\n}\n\n.productCard:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.imageContainer {\n  height: 210px;\n}\n\n.image {\n  max-height: 100%; /* Asigură că imaginea respectă proporția */\n  max-width: 100%; /* Asigură că imaginea respectă proporția */\n  margin: auto; /* Centrează imaginea pe ambele axe */\n  object-fit: contain; /* Păstrează proporțiile imaginii fără să o decupeze */\n}\n\n.productName {\n  font-size: 1.1em;\n  margin: 0;\n  color: #333;\n  display: -webkit-box; /* Suport pentru trunchiere pe mai multe linii */\n  -webkit-line-clamp: 2; /* Permite maximum 2 linii */\n  -webkit-box-orient: vertical; /* Setează direcția conținutului */\n  overflow: hidden; /* Ascunde conținutul suplimentar */\n  text-align: center;\n}\n\n.productPrice {\n  font-size: 1em;\n  color: #888;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.link {\n  text-decoration: none; /* Elimină sublinierea */\n  color: inherit; /* Menține culoarea textului */\n}\n\n.contacts {\n  display: flex;\n  gap: 10px;\n}\n\n.contact {\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.city {\n  font-size: 35px;\n  font-weight: 400;\n  color: #333;\n}\n\n.address {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n\n.mapsLink {\n  display: flex; /* Flexbox pentru afișarea orizontală */\n  align-items: center; /* Aliniere verticală */\n  gap: 8px; /* Spațiu între iconiță și text */\n  color: #e63946; /* Culoare text */\n  text-decoration: none; /* Fără subliniere */\n  font-weight: bold;\n  transition: opacity 0.3s ease; /* Tranziție pentru un efect mai plăcut */\n}\n\n.mapsLink i {\n  font-size: 20px;\n  color: #333;\n}\n\n.mapsLink span {\n  font-size: 20px;\n  font-weight: 500;\n  color: #333;\n}\n\n.mapsLink:hover {\n  opacity: 0.7; /* Face linkul mai palid */\n}\n\n.phone {\n  color: #e63946;\n  font-size: 30px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.phone:hover {\n  opacity: 0.7;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .container {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n\n  .products {\n    flex-direction: column;\n  }\n\n  .contacts {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HomePage_container__+8deC`,
	"productsLink": `HomePage_productsLink__KXY-7`,
	"title": `HomePage_title__Iqtik`,
	"products": `HomePage_products__MhUPY`,
	"product": `HomePage_product__VIYY9`,
	"productCard": `HomePage_productCard__rneTI`,
	"imageContainer": `HomePage_imageContainer__4rajJ`,
	"image": `HomePage_image__TnCdE`,
	"productName": `HomePage_productName__lD1Hf`,
	"productPrice": `HomePage_productPrice__84XfT`,
	"link": `HomePage_link__V6y8d`,
	"contacts": `HomePage_contacts__D+S3D`,
	"contact": `HomePage_contact__izQPY`,
	"city": `HomePage_city__eFPYX`,
	"address": `HomePage_address__4-Sq3`,
	"mapsLink": `HomePage_mapsLink__cfJqD`,
	"phone": `HomePage_phone__YJcpg`
};
export default ___CSS_LOADER_EXPORT___;
